export default __webpack_public_path__ + "static/media/youtube.febe8575.svg";